import "babel-polyfill";
import Vue from "vue";
import ViewUI from "view-design";
import axios from "axios";
import VueAxios from "vue-axios";
import Vue2OrgTree from "vue2-org-tree";
import App from "./App";
import router from "./router";
import VCharts from "v-charts";
import J2BPMComponent from "./components/J2BPMComponent";
import store from "./common/GlobalStore";
import "view-design/dist/styles/iview.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./css/common.css";
import echarts from "echarts";
import FormTitle from "@/components/formPageComponents/formTitle";
import FormContent from "@/components/formPageComponents/formContent";
import "./css/index.less";
import i18n from "./i18n";
import msal from "vue-msal";
import scroll from "vue-seamless-scroll";
import exportExcel from "./util/ExcelExport";
import importExcel from "./util/ExcelImport";
import notice from "./util/notice";
import donwLoad from "./util/downLoad";
import htmlToPdf from "./util/htmlToPdf";
import htmlToPdfL from "./util/htmlToPdfL";
import DateUtil from "./util/DateUtil";
// 绩效重点导入
import importExcelActive from "./util/ExcelImportActive";
import importExcelActiveGroup from "./util/ExcelImportActiveGroup";
// 绩效重点导出
import exportExcelActive from "./util/ExcelExportActive";
import exportExcelActiveGroup from "./util/ExcelExportActiveGroup";
// import '@v-charts/lib/style.min.css'

// 加载VUE插件
Vue.use(ViewUI);
Vue.use(VueAxios, axios);
Vue.use(Vue2OrgTree);
Vue.use(VCharts);
Vue.use(J2BPMComponent);
Vue.use(i18n);
Vue.use(scroll);
Vue.prototype.$echarts = echarts;
Vue.prototype.$exportExcel = exportExcel.exportToExcel;
Vue.prototype.$importExcel = importExcel.importToExcel;
Vue.prototype.$exportJsonToExcel = exportExcel.exportJsonToExcel;
Vue.prototype.$exportExcelActive = exportExcelActive.exportToExcel;
Vue.prototype.$exportExcelActiveGroup = exportExcelActiveGroup.exportToExcel;
Vue.prototype.$importExcelActive = importExcelActive.importToExcel;
Vue.prototype.$importExcelActiveGroup = importExcelActiveGroup.importToExcel;
Vue.config.productionTip = false;
Vue.prototype.$notice = notice.showNotice;
// Vue.prototype.$nowDate = new DateUtil().dateVal(new Date(),'YYYY-MM-DD HH-mm');
Vue.prototype.$nowDate = new DateUtil();
Vue.use(htmlToPdf);
Vue.use(htmlToPdfL);

// Vue.use(msal, {
//   auth: {
//     //  Myself-Azure
//     // clientId: '6e7fab7c-0fd7-4a56-97d6-fd9d85bdd9c0',
//     // tenantId: 'b16f000d-8e4c-4d5a-a7a4-1cf501680e97',
//     // redirectUri : 'http://localhost:8080/'
//     // TeLing-Azure
//     // TODO Azure配置
//     clientId: '051b5831-662a-46ea-b503-c2a4ebce2098',
//     tenantId: 'be5b5559-5a44-42dd-808c-93e6e874271f',
//     redirectUri : 'https://mecarls.carlsberg.cn'
//   },

//   cache : {
//     cacheLocation  : 'localStorage'
//   },
//   request: {
//     scopes: ["user.read", "openid", "profile"]
//   },
//   framework: {
//     globalMixin: true
//   }
// });

Vue.component("FormTitle", FormTitle);
Vue.component("FormContent", FormContent);

Vue.prototype.$donwLoad = donwLoad.download;
Vue.prototype.$removeFile = function(resource_id_List, callback) {
  return axios.post("/resource/deleteForm", { stringList: resource_id_List });
};
// axios请求拦截器
axios.interceptors.request.use(
  config => {
    // 请求设定
    config.baseURL = process.env.API_ROOT;
    config.withCredentials = true;
    config.method = "post";

    // 登陆页面
    let isLoginPage = router.currentRoute.path.startsWith("/login/");

    // Token信息
    config.headers = {};
    let token =
      store.getters.accessToken || sessionStorage.getItem("accessToken");
    if (!isLoginPage && token) {
      config.headers["access-token"] = token;
    }

    if (!config.headers["loginType"]) {
      let loginType = config.headers["loginType"];
      Vue.use(msal, {
        auth: {
          // TODO Azure配置
          clientId: "051b5831-662a-46ea-b503-c2a4ebce2098",
          tenantId: "be5b5559-5a44-42dd-808c-93e6e874271f",
          // loginType = 1 我的档案
          // loginType = 2 持续沟通
          // loginType = 3 团队情况
          redirectUri:
            loginType == 1
              ? "https://mecarls.carlsberg.cn/?loginType=1"
              : loginType == 2
              ? "https://mecarls.carlsberg.cn/?loginType=2"
              : loginType == 3
              ? "https://mecarls.carlsberg.cn/?loginType=3"
              : "https://mecarls.carlsberg.cn"
        },
        cache: {
          cacheLocation: "localStorage"
        },
        request: {
          scopes: ["user.read", "openid", "profile"]
        },
        framework: {
          globalMixin: true
        }
      });
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// axios响应拦截器
axios.interceptors.response.use(
  response => {
    let resultHeader = response.headers;
    let resultData = response.data;
    store.getters.pageData.axiosHeader = resultHeader;

    if (resultData.result == null) {
      let contentType = resultHeader["content-type"];
      if (contentType && contentType.indexOf("application/json") > -1) {
        resultData = JSON.parse(
          String.fromCharCode.apply(null, new Int8Array(resultData))
        );
      }
    }

    // 正常响应返回响应数据
    if (resultData.result == "0") {
      return resultData.data;
    }

    // 登陆响应跳转到登陆页面
    if (resultData.result == "1") {
      let pageId = store.getters.curPageId;
      if (pageId) {
        if (store.getters.userInfo != null) {
          ViewUI.Message.error("当前用户操作权限不足！");
        } else {
          router.push("/login" + pageId);
        }
      } else {
        router.push("/login");
      }
      return resultData.data;
    }

    // 错误响应弹出错误提示
    if (resultData.result == "9") {
      ViewUI.Message.error(resultData.errorMessage);
      return resultData.data;
    }
    // 错误响应返回国际化
    if (resultData.result == "10") {
      ViewUI.Message.error(vue.$t(resultData.errorMessage));
      return resultData.data;
    }
    // 拼接格式错误返回国际化
    if (resultData.result == "11") {
      // if(vue.i18n == 'zh'){
      ViewUI.Message.error(resultData.chValue);
      // }else{
      //   ViewUI.Message.error(resultData.enValue);
      // }
      return resultData.data;
    }

    return resultData;
  },
  error => {
    switch (error.response.status) {
      // 登陆响应跳转到登陆页面
      case 401:
        ViewUI.Message.error(error.response.data.message);

        //域登入超時退出
        if (vue.$msal.data.user.idToken) {
          vue.$msal.signOut();
        }
        //正常超時退出
        else {
          let pageId = store.getters.curPageId;
          if (pageId) {
            router.push("/login" + pageId);
          } else {
            router.push("/login");
          }
        }
        break;
      // 错误响应弹出错误提示
      default:
        ViewUI.Message.error("通信请求错误");
    }
    return Promise.reject(error);
  }
);

// 初始化VUE对象
var vue = new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
});
window.j2r = vue.$router;



// WEBPACK FOOTER //
// ./src/main.js